import { render } from "./UserDeleteFormModal.vue?vue&type=template&id=a060aaa8&lang=pug"
import script from "./UserDeleteFormModal.vue?vue&type=script&lang=ts"
export * from "./UserDeleteFormModal.vue?vue&type=script&lang=ts"
script.render = render

export default script